export default __webpack_public_path__ + "static/media/3334 spice rack B top.84649a49.png";